export const HISTORY_SCOPE = {
  DUBBING: 'dubbing',
};

export const HISTORY_LABEL = {
  EDIT_BLOCK_TEXT: 'edit_block_text',
  APPLY_REWRITE: 'apply_rewrite',
  CHANGE_BLOCK_VOICE: 'change_block_voice',
  ADD_BLOCK: 'add_block',
  DELETE_BLOCK: 'delete_block',
  CHANGE_BLOCK_SPEED: 'change_block_speed',
  CHANGE_BLOCK_EMPHASIS: 'change_block_emphasis',
  DELETE_BLOCKS: 'delete_blocks',
  SPLIT_BLOCK: 'split_block',
  MERGE_BLOCK: 'merge_block',
  CHANGE_BLOCK_TIMING: 'change_block_timing',
  COMPACTED_SPEAKER_CHANGE: 'compacted_speaker_change',
  FILTER_STATUS: 'filter_status',
  FILTER_SPEAKER: 'filter_speaker',
  ADD_MUSIC_CLIP: 'add_music_clip',
  MOVE_MUSIC_CLIP: 'move_music_clip',
  TRIM_MUSIC_CLIP: 'trim_music_clip',
  REPLACE_MUSIC_CLIP: 'replace_music_clip',
  DUPLICATE_MUSIC_CLIP: 'duplicate_music_clip',
  DELETE_MUSIC_CLIP: 'delete_music_clip',
  CHANGE_TRACK_VOLUME: 'change_track_volume',
  APPLY_CAPTION_STYLE: 'apply_caption_style',
  CHANGE_CAPTION_STYLE: 'change_caption_style',
};

export const HISTORY_SHORTCUT_OPT_IN = 'dubbing';

export const HISTORY_MAX_STACK = 50;

// Object keys whose value is a speaker id reference. Used by the history
// service to detect and compact patches that point at a deleted speaker.
export const SPEAKER_REFERENCE_KEYS = new Set([
  'speakerId',
  'currentFilteringSpeakerId',
]);
